module.exports = __webpack_public_path__ + "static/img/settingIcon.275213f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting/settingIcon.svg
// module id = C2Zv
// module chunks = 0